import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { composeCPProductId } from '~/common/contactpigeon';
import useProductCard from '../ProductCard/lib/useProductCard';
import ProductCardImage from './ProductCardLargeImage';
import ProductCardSizes from './ProductCardLargeSizes';

const ProductCardLarge = ({ product }) => {
	const { t } = useTranslation();
	const handledProduct = { ...product, ...useProductCard(product) };

	return (
		<>
			<div className="product-large-card" data-product-id={composeCPProductId(product, false)}>
				<Link to={handledProduct.eurl}>
					<div className="product-details">
						<h2>{product.nm}</h2>
						<h4 className="small-desc" title={product.dsm} dangerouslySetInnerHTML={{ __html: product.dsm }}></h4>
						<ProductCardImage handledProduct={handledProduct} />
					</div>
				</Link>
				<ProductCardSizes handledProduct={handledProduct} />
			</div>
		</>
	);
};

ProductCardLarge.propTypes = {
	product: PropTypes.object
};

export default ProductCardLarge;
